// src/auth/token.js
const ACCESS_TOKEN_KEY = 'token';
const EXPIRES_AT_KEY = 'token_expires_at'; // opcional (epoch ms); usalo si tu API lo devuelve

export function getToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY) || null;
}

export function setToken(token, expiresAtMs) {
  if (token) localStorage.setItem(ACCESS_TOKEN_KEY, token);
  if (expiresAtMs) localStorage.setItem(EXPIRES_AT_KEY, String(expiresAtMs));
}

export function clearToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(EXPIRES_AT_KEY);
}

export function isTokenNearExpiry(bufferSeconds = 30) {
  const raw = localStorage.getItem(EXPIRES_AT_KEY);
  if (!raw) return false;
  const expiresAt = Number(raw);
  if (!expiresAt) return false;
  const now = Date.now();
  return now >= expiresAt - bufferSeconds * 1000;
}
